// Librerías
import React from 'react'

const ExpanderComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;

export default ExpanderComponent
